import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  step1: {}, 
  step2: {}, 
  step3: {}, 
  step4: {},
  step5: {}, 
  step6: {}, 
  additionalData: {}, 
  skillsData: {}, 
  careerData: [],
  isCareerDataLoaded: false,
  isDirty: false,
  currentStep: 1,
  isFormLoaded: false,
  shouldValidate: false,
  validationStep: null
};

const profileFormSlice = createSlice({
  name: "profileForm",
  initialState,
  reducers: {
    updateStep: (state, action) => {
      const { step, data } = action.payload;
      state[step] = data;
      state.isDirty = true;
    },
    updateSkillsData: (state, action) => {
      const { jobId, skills } = action.payload;
      state.skillsData[jobId] = skills;
    },
    updateCareerData: (state, action) => {
      state.careerData = action.payload;
      state.isCareerDataLoaded = true;
    },
    clearSkillsCache: (state) => {
      state.skillsData = {};
    },
    clearCareerDataCache: (state) => {
      state.careerData = [];
      state.isCareerDataLoaded = false;
    },
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },
    clearDirty: (state) => {
      state.isDirty = false;
    },
    setFormLoaded: (state, action) => {
      state.isFormLoaded = action.payload;
    },
    loadProfileData: (state, action) => {
      const profileData = action.payload;
      
      state.step1 = {
        currentSituation: profileData.currentSituation || []
      };
      
      state.step2 = {
        interestReason: profileData.interestReason || []
      };
      
      state.step3 = {
        firstName: profileData.firstName || "",
        lastName: profileData.lastName || "",
        gender: profileData.gender || "",
        country: profileData.country || "",
        state: profileData.stateOrProvince || "",
        city: profileData.city || "",
        age: profileData.age || "",
        race: profileData.race || "",
        email: profileData.email || ""
      };
      
      state.step4 = {
        education: profileData.highestLevelEducation || "",
        status: profileData.employmentStatus || "",
        experience: profileData.professionalExperience || "",
        workYears: profileData.yearsOfExperience || ""
      };

      state.step5 = {
        currentJob: profileData.currentJob || "",
        industry: profileData.industry || "",
        // commonSkills: profileData.commonSkills || [],
        // definingSkills: profileData.definingSkills || [],
        // distinguishingSkills: profileData.distinguishingSkills || [],
        // salaryBoostingSkills: profileData.salaryBoostingSkills || [],
        // certifications: profileData.certifications || []
      };

      // Step 6 - AI Skills & Careers (commented out)
      // state.step6 = {
      //   AILiteracySkills: profileData.AILiteracySkills || [],
      //   appliedAISkills: profileData.appliedAISkills || [],
      //   aiCareers: profileData.aiCareers || [],
      //   ethicsResponsibleAI: profileData.ethicsResponsibleAI || [],
      //   softAISkills: profileData.softAISkills || [],
      //   strategicAISkills: profileData.strategicAISkills || [],
      //   technicalAISkills: profileData.technicalAISkills || [],
      //   ai_application: profileData.ai_application || []
      // };

      // Step 6 - Documents Upload (previously step7)
      state.step6 = {
        profileImage: profileData.profileImage || profileData.profilePhoto || "",
        cv: profileData.cv || {}
      };
      
      state.additionalData = {
        currentJobDescription: profileData.currentJobDescription || "",
        occupationId: profileData.occupationId || "",
        emergingAISkills: profileData.emergingAISkills || "",
      };
      
      if (typeof profileData.currentStep === 'number') {
        state.currentStep = profileData.currentStep;
      }

      state.isFormLoaded = true;
      state.isDirty = false;
    },
    resetForm: () => initialState,
    triggerValidation: (state, action) => {
      state.shouldValidate = true;
      state.validationStep = action.payload; 
    },
    clearValidation: (state) => {
      state.shouldValidate = false;
      state.validationStep = null;
    }
  }
});

export const {
  updateStep,
  updateSkillsData,
  updateCareerData,
  clearSkillsCache,
  clearCareerDataCache,
  setCurrentStep,
  clearDirty,
  setFormLoaded,
  loadProfileData,
  resetForm,
  triggerValidation,
  clearValidation
} = profileFormSlice.actions;

export const selectSkillsForJob = (state, occupationId) => state.profileForm.skillsData[occupationId];
export const selectAllSkillsData = (state) => state.profileForm.skillsData;

export default profileFormSlice.reducer; 